import {LinkedAccount} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/linkedaccount';
import {YelpConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/yelpconfiguration';
import {LinkedAccounts} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/linkedaccounts/linkedaccounts';
import {SkipSetup} from '/src/com/yext/listingslaunchstorm/js/enterprise/skipsetup/skipsetup';

/**
 * @param {{
 *   publisherId: number,
 *   yelpConfiguration: YelpConfiguration,
 *   setYelpConfiguration: function(YelpConfiguration): void,
 * }} props
 */
export function YelpLinkedAccount({
  publisherId,
  yelpConfiguration,
  setYelpConfiguration,
}) {
  const configuredLinkedAccount = yelpConfiguration.linkedAccount;

  /**
   * @param {LinkedAccount=} linkedAccount
   */
  function setLinkedAccount(linkedAccount) {
    if (configuredLinkedAccount?.id === linkedAccount?.id) {
      // The set function is called when the LinkedAccounts component first loads. Detect this and
      // similar cases where the selection hasn't changed so that we don't set unneccessarily.
      return;
    }
    const skipSetup = yelpConfiguration.skipSetup;
    const syncedFieldSettings = yelpConfiguration.syncedFieldSettings;
    setYelpConfiguration(
      new YelpConfiguration({
        linkedAccount,
        skipSetup,
        syncedFieldSettings,
      }));
  }

  /**
   * @param {boolean} skipSetup
   */
  function setSkipYelpConfiguration(skipSetup) {
    const linkedAccount = yelpConfiguration.linkedAccount;
    const syncedFieldSettings = yelpConfiguration.syncedFieldSettings;

    setYelpConfiguration(
      new YelpConfiguration({
        linkedAccount,
        skipSetup,
        syncedFieldSettings,
      }));
  }

  return (
    <>
      <LinkedAccounts
        publisherId={publisherId}
        linkedAccount={configuredLinkedAccount}
        setLinkedAccount={setLinkedAccount}
        isTest={false}
        skipSetup={yelpConfiguration.skipSetup}
      />
      <SkipSetup
        skipSetup={yelpConfiguration.skipSetup}
        disabled={false}
        onClick={() => {
          setSkipYelpConfiguration(!yelpConfiguration.skipSetup);
        }}
        tooltipText={yext.msg(
          'By skipping this step, you will not set up your configuration to send your entities to Yelp. If you would like to set this up in the future, you can go through the Listings Launch flow again.',
        )}
      />
    </>
  );
}
